import { Link } from "react-router-dom";
import "./PricingCardStyles.css";

import React from "react";

const PricingCard = () => {
  return (
    <div className="pricing">
      <h1 className="certificado">Certificaciones</h1>
      <div className="card-container">
        <div className="card">
          <h3>-Web Responsive-</h3>
          <span className="bar"></span>
          <p className="btc">HTML & CSS</p>
          <p>- Diseño Web Adaptativo -</p>
          <Link to="https://www.freecodecamp.org/certification/fcc2e49738b-7339-4058-9df7-c7bf82984cfd/responsive-web-design" className="btn" target="_blank">
            Certificado
          </Link>
        </div>

        <div className="card">
          <h3>-Algorithm and Structure-</h3>
          <span className="bar"></span>
          <p className="btc">JavaScript</p>
          <p>- Algoritmos de JavaScript y Estructura de Datos -</p>
          <Link to="https://www.freecodecamp.org/certification/fcc2e49738b-7339-4058-9df7-c7bf82984cfd/javascript-algorithms-and-data-structures-v8" className="btn" target="_blank">
            Certificado
          </Link>
        </div>

        <div className="card">
          <h3>-Front End Libraries-</h3>
          <span className="bar"></span>
          <p className="btc">React & Redux</p>
          <p>- Bibliotecas de desarrollo front-end con React y Redux-</p>
          <Link to="https://www.freecodecamp.org/certification/fcc2e49738b-7339-4058-9df7-c7bf82984cfd/front-end-development-libraries" className="btn" target="_blank">
            Certificado
          </Link>
        </div>

        
      </div>
    </div>
  );
};

export default PricingCard;
